import Model from './base';

export class PriceRequestItem extends Model {
  resource() {
    return 'order/price-request-item';
  }

  defaultAttributes() {
    return {
      amount: null,
      price_request: null,
      product: {},
    }
  }
}

export class PriceRequest extends Model {
  resource() {
    return 'order/price-request';
  }

  defaultAttributes() {
    return {
      comment: null,
      request_date: null,
      price_request_items: [],
    }
  }
}
